import '../../styles/web-components/product-option-dropdown.scss';
class ProductOptionDropdown extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('change', this.handleOptionChanged);
        this.windowClick = this.onWindowClick.bind(this);
    }
    windowClick;
    id;
    connectedCallback() {
        this.id = this.querySelector('.product-option-dropdown__select')?.id;
        window.addEventListener("click", this.windowClick);
        this.querySelector('.product-option-dropdown__select-button').addEventListener("click", (e) => {
            const target = e.target;
            this.querySelector(".product-option-dropdown__select")?.classList.toggle("active");
            target.setAttribute("aria-expanded", target.getAttribute("aria-expanded") === "true" ? "false" : "true");
        });
    }
    disconnectedCallback() {
        window.removeEventListener("click", this.windowClick);
    }
    handleOptionChanged(e) {
        console.debug("ProductOptionDropdown handleOptionChanged", e.target);
        const target = e.target;
        this.querySelector(".product-option-dropdown__select")?.classList.remove("active");
        const event = new CustomEvent("dropdown:valueChanged", { detail: { [target.name]: target.value }, bubbles: true });
        this.dispatchEvent(event);
    }
    onWindowClick(e) {
        const target = e.target;
        if (!(target.id === this.firstElementChild.id || target.closest(`#${this.firstElementChild.id}`))) {
            this.querySelector(".product-option-dropdown__select")?.classList.remove("active");
            this.querySelector(".product-option-dropdown__select-button")?.setAttribute("aria-expanded", "false");
        }
    }
}
if (!window.customElements.get("product-option-dropdown")) {
    customElements.define("product-option-dropdown", ProductOptionDropdown);
}
